module.exports = __webpack_public_path__ + "img/transfer_img_en.ba23231e.png";